import type { ImagePreview } from './const';
import { MAX_IMAGES } from './const';
import { useFeedbackModalStore } from './store';

/** 文件校验结果 */
export interface FileValidationResult {
  validFiles: File[];
  invalidFiles: File[];
  oversizedFiles: File[];
  hasErrors: boolean;
}

/** 验证是否为有效的图片文件 */
export function isValidImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

/** 生成文件唯一标识 */
function getFileKey(file: File): string {
  return `${file.name}-${file.size}-${file.lastModified}`;
}

/** 对文件列表进行去重 */
export function deduplicateFiles(files: File[]): File[] {
  const uniqueFiles: File[] = [];
  const seen = new Set<string>();

  for (const file of files) {
    const key = getFileKey(file);
    if (!seen.has(key)) {
      seen.add(key);
      uniqueFiles.push(file);
    }
  }

  return uniqueFiles;
}

/** 过滤掉已存在的文件 */
export function filterExistingFiles(files: File[], existingImages: ImagePreview[]): File[] {
  const existingKeys = new Set(existingImages.map(img => getFileKey(img.file)));
  return files.filter(file => !existingKeys.has(getFileKey(file)));
}

/** 处理文件列表，创建图片对象 */
export function processImageFiles(files: FileList | File[]): ImagePreview[] {
  const fileArray = Array.from(files);
  return fileArray
    .filter(isValidImageFile)
    .slice(0, MAX_IMAGES)
    .map(file => ({
      file,
      uploading: true, // 标记为上传中
    }));
}

/** 从剪贴板粘贴事件中提取图片 */
export function extractImagesFromPaste(event: ClipboardEvent): File[] {
  const items = event.clipboardData?.items;
  if (!items) {
 return [];
}

  const imageFiles: File[] = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.type.startsWith('image/')) {
      const file = item.getAsFile();
      if (file) {
        imageFiles.push(file);
      }
    }
  }
  return imageFiles;
}

/** 打开反馈弹窗 */
export function openFeedbackModal(source: string, options: { context?: Record<string, unknown> } = {}) {
  useFeedbackModalStore.setState({
    visible: true,
    context: {
      ...options.context,
      source,
      href: window.location.href,
    },
  });
}

/** 关闭反馈弹窗 */
export function closeFeedbackModal() {
  useFeedbackModalStore.setState({
    visible: false,
    context: null,
  });
}
